import { styled } from '@mui/material/styles';
import MuiCardMedia from '@mui/material/CardMedia';

export const CardMedia = styled(MuiCardMedia)(() => ({
  borderRadius: '100%',
  width: '45px',
  height: '45px'
})) as typeof MuiCardMedia;
